export default{
    supplierName: "商家名称",
    mainCategory: "经营类目",
    contactName: "联系人名称",
    contactPhoneNumber: "联系电话",
    warehouseAddr: "仓库地址",
    setPassword: "设置密码",
    confirmPassword: "确认密码",
    legalPersonsname: "法人姓名",
    legalPersonPhoneNumber: "法人手机号码",
    legalPersonsIDCard: "法人身份证",
    IDPhoto: "身份证件照片",
    whetherThreeCertificatesAreInOne: "是否三证合一",
    unifiedSocialCreditCode: "统一社会信用码",
    operatingPeriod: "营业期限",
    businessLicense: "营业执照",
    long: "长期"

}